import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";
import { SupportArticleLinks } from "@src/appV2/support/constants";

export function useSkillsAssessmentFeatureFlags() {
  const isSkillsAssessmentOnboardingEnabled = useCbhFlag(
    CbhFeatureFlag.ROLLOUT_SKILLS_ASSESSMENT_DURING_ONBOARDING,
    {
      defaultValue: false,
    }
  );
  const skillsAssessmentConfig = useCbhFlag(CbhFeatureFlag.SKILLS_ASSESSMENTS_CONFIG, {
    defaultValue: {
      cooldownTimeAfterFailureInDays: 7,
      availableQualificationNames: ["CNA"],
      maxNumberOfVerifiedShiftsAllowedToBeEligible: 15,
      passPercentage: 0.5,
      supportArticleLink: SupportArticleLinks.SKILLS_ASSESSMENT_CONFIG,
    },
  });
  const scheduledAssessmentConfig = useCbhFlag(CbhFeatureFlag.SCHEDULED_ASSESSMENTS_CONFIG, {
    defaultValue: {
      allowedEarlinessInMinutes: 5,
      allowedLatenessInMinutes: 60,
      hoursUntilAutomaticalFailForBeingLate: 2,
      reminderSchedule: [],
      minimumLeadTimeToScheduleAssessmentInHours: 12,
      maximumLeadTimeToScheduleAssessmentInHours: 72,
      rescheduleLeadTimeInMinutes: 60,
      allowedTimeRange: {
        start: {
          hour: 7,
          minute: 0,
        },
        end: {
          hour: 23,
          minute: 0,
        },
      },
    },
  });

  const rolloutScheduledSkillAssessmentConfig = useCbhFlag(
    CbhFeatureFlag.ROLLOUT_SCHEDULED_SKILL_ASSESSMENT,
    {
      defaultValue: {
        isEnabled: false,
        isClipboardOrientationEnabled: false,
        qualificationPriority: [],
      },
    }
  );

  return {
    isSkillsAssessmentOnboardingEnabled,
    skillsAssessmentConfig,
    scheduledAssessmentConfig,
    isClipboardOrientationEnabled:
      rolloutScheduledSkillAssessmentConfig.isClipboardOrientationEnabled,
  };
}
